/* eslint-disable no-underscore-dangle */
import { Link, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function CookiesButton() {
    const { t } = useTranslation('navigation');

    if (!window._iub?.cs?.api?.openPreferences) {
        return null;
    }

    return (
        <StyledTypography component={ Link }
            variant="body2"
            onClick={ () => window._iub.cs.api.openPreferences() }
        >
            { t('navigationItem.cookies') }
        </StyledTypography>
    );
}

const StyledTypography = styled(Typography)({
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: 12
}) as typeof Typography;
